<template>
  <div :style="{ minHeight: 'max(884px, 100dvh)' }" class="text-on-surface" style="background-color: #f9f9fa;">
    <!-- TopAppBar -->
    <header class="sticky top-0 w-full z-50 bg-surface dark:bg-surface-dim shadow-sm flex items-center justify-between px-container-margin py-base gap-gutter">
      <div class="w-10"></div>
      <h1 class="font-headline-sm text-headline-sm font-bold text-primary">我的</h1>
      <div class="w-10"></div>
    </header>

    <main class="pb-32">
      <!-- Hero Header Section -->
      <section class="px-container-margin pt-stack-lg pb-stack-lg bg-surface-container-lowest">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-stack-lg">
            <div class="relative">
              <img
                alt="用户头像"
                class="w-20 h-20 rounded-full object-cover border-2 border-primary-container shadow-sm"
                :src="avatarUrl"
              />
            </div>
            <div>
              <h2 class="font-headline-md text-headline-md text-on-surface">{{ username }}</h2>
              <p class="font-label-md text-label-md text-on-surface-variant mt-1 line-clamp-1">{{ bio }}</p>
              <router-link
                v-if="isLoggedIn"
                class="font-label-md text-label-md text-primary flex items-center gap-1 mt-1 active:opacity-70 transition-opacity"
                :to="{ name: 'edit-profile' }"
              >
                编辑资料
                <span class="material-symbols-outlined text-[14px]">edit</span>
              </router-link>
              <router-link
                v-else
                class="font-label-md text-label-md text-primary flex items-center gap-1 mt-1 active:opacity-70 transition-opacity"
                :to="{ name: 'login' }"
              >
                登录/注册
                <span class="material-symbols-outlined text-[14px]">login</span>
              </router-link>
            </div>
          </div>
          <div
            v-if="isLoggedIn"
            class="profile-stars-btn active:scale-95 transition-transform cursor-pointer"
            role="button"
            tabindex="0"
            @click="$router.push({ name: 'my-follows' })"
          >
            <span class="material-symbols-outlined text-primary-container" style="font-variation-settings: 'FILL' 1;">stars</span>
          </div>
        </div>

        <!-- Quick Stats -->
        <div v-if="isLoggedIn" class="grid grid-cols-3 gap-gutter mt-stack-lg">
          <div
            class="bg-surface-container flex flex-col items-center justify-center py-stack-md rounded-xl active:scale-95 transition-transform cursor-pointer"
            role="button"
            tabindex="0"
            @click="$router.push({ name: 'my-products' })"
          >
            <span class="font-headline-sm text-headline-sm text-on-surface">{{ goodsCount }}</span>
            <span class="font-label-md text-label-md text-on-surface-variant">我的出售</span>
          </div>
          <div
            class="bg-surface-container flex flex-col items-center justify-center py-stack-md rounded-xl active:scale-95 transition-transform cursor-pointer"
            role="button"
            tabindex="0"
            @click="$router.push({ name: 'my-wanted' })"
          >
            <span class="font-headline-sm text-headline-sm text-on-surface">{{ goodsWanna }}</span>
              <span class="font-label-md text-label-md text-on-surface-variant">我的求购</span>
            <!-- <span class="font-label-md text-label-md text-on-surface-variant">粉丝</span> -->
          </div>
          <div
            class="bg-surface-container flex flex-col items-center justify-center py-stack-md rounded-xl active:scale-95 transition-transform cursor-pointer"
            role="button"
            tabindex="0"
            @click="$router.push({ name: 'my-favorites' })"
          >
            <span class="font-headline-sm text-headline-sm text-on-surface">{{ goodsSave }}</span>
              <span class="font-label-md text-label-md text-on-surface-variant">我的收藏</span>
            <!-- <span class="font-label-md text-label-md text-on-surface-variant">关注</span> -->
          </div>
        </div>
        <p v-if="profileError" class="mt-stack-md text-error font-label-md text-label-md" role="alert">{{ profileError }}</p>
      </section>

      <!-- Asymmetric Bento Menu -->
      <section class="px-container-margin mt-stack-lg">
        <h3 class="font-headline-sm text-headline-sm mb-stack-md px-1">设置与支持</h3>
        <div class="grid grid-cols-2 gap-gutter">
          <!-- My Products Card -->
          <div
            v-if="isLoggedIn"
            class="col-span-2 bg-surface-container-lowest p-stack-lg rounded-3xl shadow-[0_4px_12px_rgba(0,0,0,0.05)] flex items-center justify-between hover:bg-surface-container-high transition-colors cursor-pointer group"
            role="button"
            tabindex="0"
            @click="$router.push({ name: 'my-products' })"
          >
            <div class="flex items-center gap-stack-lg">
              <div class="w-12 h-12 rounded-2xl bg-secondary-container flex items-center justify-center text-on-secondary-container group-active:scale-90 transition-transform">
                <span class="material-symbols-outlined" style="font-variation-settings: 'FILL' 1;">inventory_2</span>
              </div>
              <div>
                <p class="font-body-lg text-body-lg font-semibold">我的商品</p>
                <p class="font-label-md text-label-md text-on-surface-variant">管理已发布的宝贝</p>
              </div>
            </div>
            <span class="material-symbols-outlined text-on-surface-variant">chevron_right</span>
          </div>

          <!-- Account Settings -->
          <div
            v-if="isLoggedIn"
            class="col-span-2 bg-surface-container-lowest p-stack-lg rounded-3xl shadow-[0_4px_12px_rgba(0,0,0,0.05)] flex items-center justify-between hover:bg-surface-container-high transition-colors cursor-pointer group"
            role="button"
            tabindex="0"
            @click="$router.push({ name: 'account-setting' })"
          >
            <div class="flex items-center gap-stack-lg">
              <div class="w-12 h-12 rounded-2xl bg-primary-fixed flex items-center justify-center text-primary group-active:scale-90 transition-transform">
                <span class="material-symbols-outlined" style="font-variation-settings: 'FILL' 1;">manage_accounts</span>
              </div>
              <div>
                <p class="font-body-lg text-body-lg font-semibold">账户设置</p>
                <p class="font-label-md text-label-md text-on-surface-variant">安全与偏好</p>
              </div>
            </div>
            <span class="material-symbols-outlined text-on-surface-variant">chevron_right</span>
          </div>

          <!-- My Favorites -->
          <!-- <div
            class="col-span-2 bg-surface-container-lowest p-stack-lg rounded-3xl shadow-[0_4px_12px_rgba(0,0,0,0.05)] flex items-center justify-between hover:bg-surface-container-high transition-colors cursor-pointer group"
            role="button"
            tabindex="0"
            @click="$router.push({ name: 'my-favorites' })"
          >
            <div class="flex items-center gap-stack-lg">
              <div class="w-12 h-12 rounded-2xl bg-error-container/20 flex items-center justify-center text-error group-active:scale-90 transition-transform">
                <span class="material-symbols-outlined" style="font-variation-settings: 'FILL' 1;">favorite</span>
              </div>
              <div>
                <p class="font-body-lg text-body-lg font-semibold">我的收藏</p>
                <p class="font-label-md text-label-md text-on-surface-variant">保存的心仪宝贝</p>
              </div>
            </div>
            <span class="material-symbols-outlined text-on-surface-variant">chevron_right</span>
          </div> -->

          <!-- My Follows -->
          <!-- <div
            class="col-span-2 bg-surface-container-lowest p-stack-lg rounded-3xl shadow-[0_4px_12px_rgba(0,0,0,0.05)] flex items-center justify-between hover:bg-surface-container-high transition-colors cursor-pointer group"
            role="button"
            tabindex="0"
            @click="$router.push({ name: 'my-follows' })"
          >
            <div class="flex items-center gap-stack-lg">
              <div class="w-12 h-12 rounded-2xl bg-tertiary-container flex items-center justify-center text-on-tertiary-container group-active:scale-90 transition-transform">
                <span class="material-symbols-outlined" style="font-variation-settings: 'FILL' 1;">groups</span>
              </div>
              <div>
                <p class="font-body-lg text-body-lg font-semibold">我的关注</p>
                <p class="font-label-md text-label-md text-on-surface-variant">关注的卖家和圈子</p>
              </div>
            </div>
            <span class="material-symbols-outlined text-on-surface-variant">chevron_right</span>
          </div> -->

          <!-- Small Grid Items -->
          <div
            class="bg-surface-container-lowest p-stack-lg rounded-3xl shadow-[0_4px_12px_rgba(0,0,0,0.05)] flex flex-col gap-stack-md active:scale-95 transition-all cursor-pointer"
            role="button"
            tabindex="0"
            @click="$router.push({ name: 'help-center' })"
          >
            <div class="w-10 h-10 rounded-xl bg-secondary-container flex items-center justify-center text-on-secondary-container">
              <span class="material-symbols-outlined">help</span>
            </div>
            <p class="font-body-md text-body-md font-semibold">帮助中心</p>
          </div>

          <div
            class="bg-surface-container-lowest p-stack-lg rounded-3xl shadow-[0_4px_12px_rgba(0,0,0,0.05)] flex flex-col gap-stack-md active:scale-95 transition-all cursor-pointer"
            role="button"
            tabindex="0"
            @click="$router.push({ name: 'privacy', query: { type: 'ysxy' } })"
          >
            <div class="w-10 h-10 rounded-xl bg-tertiary-container flex items-center justify-center text-on-tertiary-container">
              <span class="material-symbols-outlined">gavel</span>
            </div>
            <p class="font-body-md text-body-md font-semibold">隐私政策</p>
          </div>

          <!-- Logout -->
          <div
            v-if="isLoggedIn"
            class="col-span-2 bg-error-container/20 border border-error-container p-stack-lg rounded-3xl flex items-center justify-center gap-stack-sm active:scale-95 transition-all cursor-pointer group"
            role="button"
            tabindex="0"
            @click="handleLogout"
          >
            <span class="material-symbols-outlined text-error group-active:translate-x-1 transition-transform">logout</span>
            <p class="font-body-lg text-body-lg font-bold text-error">退出登录</p>
          </div>
        </div>
      </section>

      <!-- Dynamic Login Prompt Overlay -->
      <div
        v-if="showLoginPrompt"
        class="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 backdrop-blur-sm px-container-margin"
        @click.self="showLoginPrompt = false"
      >
        <div class="bg-surface w-full max-w-sm rounded-[32px] p-stack-lg text-center shadow-2xl">
          <div class="w-16 h-16 bg-primary-container rounded-full flex items-center justify-center mx-auto mb-stack-lg">
            <span class="material-symbols-outlined text-on-primary-container text-display-lg">lock</span>
          </div>
          <h4 class="font-headline-md text-headline-md mb-2">欢迎回来</h4>
          <p class="font-body-md text-body-md text-on-surface-variant mb-stack-lg">登录以访问您的个性化销售面板并查看已保存项目。</p>
          <button
            class="w-full h-12 bg-primary text-on-primary rounded-full font-body-lg font-bold active:scale-95 transition-transform mb-base"
            type="button"
            @click="$router.push({ name: 'login' })"
          >立即登录</button>
          <button
            class="w-full h-12 bg-transparent text-on-surface-variant rounded-full font-label-md active:opacity-50 transition-opacity"
            type="button"
            @click="showLoginPrompt = false"
          >稍后再说</button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import getApi from '@/api';
import store from '@/store';
import pageActivate from '@/mixins/pageActivate';

const api = getApi();
const FALLBACK_AVATAR = require('@/assets/images/8ca7cfcc1ddc.jpg');

export default {
  name: 'profile',
  mixins: [pageActivate],
  data() {
    return {
      avatarUrl: FALLBACK_AVATAR,
      username: 'Alex Rivera',
      bio: '欢迎来到我的主页',
      goodsCount: '0',
      goodsWanna: '0',
      goodsSave: '0',
      profileError: '',
      showLoginPrompt: false
    };
  },
  computed: {
    isLoggedIn() {
      return store.isLoggedIn;
    }
  },
  methods: {
    setText(field, value, fallback) {
      this[field] = (value == null || value === '') ? fallback : String(value);
    },

    renderProfile(profile) {
      profile = profile || {};
      if (!Object.keys(profile).length) return;

      if (profile.avatar) {
        this.avatarUrl = profile.avatar;
      }
      this.setText('username', profile.username, '未命名用户');
      this.setText('bio', profile.bio, '这个人很低调，还没有填写简介');
      this.setText('goodsCount', profile.goods_count, '0');
      this.setText('goodsWanna', profile.goods_wanna, '0');
      this.setText('goodsSave', profile.goods_save, '0');

      this.syncProfileStore(profile);
    },

    syncProfileStore(profile) {
      if (!profile || !Object.keys(profile).length) return;
      const existing = store.state.userinfo || {};
      store.setUserinfo(Object.assign({}, existing, {
        id: profile.id != null ? profile.id : existing.id,
        username: profile.username != null ? profile.username : existing.username,
        avatar: profile.avatar != null ? profile.avatar : existing.avatar,
        bio: profile.bio != null ? profile.bio : existing.bio,
        tags: profile.tags != null ? profile.tags : existing.tags,
        circle_list: profile.circle_list != null ? profile.circle_list : existing.circle_list
      }));
    },

    resetGuestProfile() {
      this.avatarUrl = FALLBACK_AVATAR;
      this.username = '未登录用户';
      this.bio = '';
      this.goodsCount = '0';
      this.goodsWanna = '0';
      this.goodsSave = '0';
    },

    loadProfile() {
      this.profileError = '';

      const token = store.state.token;
      if (!token) {
        this.resetGuestProfile();
        this.showLoginPrompt = false;
        return;
      }

      api.userInfo(token)
        .then(profile => {
          this.renderProfile(profile);
          this.profileError = '';
          this.showLoginPrompt = false;
        })
        .catch(error => {
          this.profileError = error.message || '个人资料加载失败，请稍后再试';
        });
    },

    handleLogout() {
      var token = store.state.token || '';
      if (token) {
        api.logout(token).catch(function () { /* server logout best-effort */ });
      }
      // Always clear local state and redirect to login
      store.clearAuth();
      this.$router.push({ name: 'login' });
    },

    onActivated() {
      this.loadProfile();
    }
  },
  mounted() {
    this.loadProfile();

    // Listen for profile updates from other pages
    document.addEventListener('profileupdated', event => {
      if (event.detail) {
        this.renderProfile(event.detail);
      } else {
        this.loadProfile();
      }
    });
  }
};
</script>

<style scoped>
body {
  background-color: #f9f9fa;
  font-family: 'Inter', sans-serif;
  -webkit-tap-highlight-color: transparent;
}
.material-symbols-outlined {
  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
}
.custom-blur {
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}
.profile-stars-btn {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background: rgba(255, 184, 0, 0.1);
}
</style>
